import { SectionContainerType } from 'common/components/entities/Section/types/SectionInterface'
import { BackgroundStylesInterface } from 'common/types/background-interfaces'
import {
  backgroundImageFixForIOS,
  containerCss,
  getDetectedBackgroundStyles,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

interface SectionUiProps extends SectionContainerType {
  htmlAttrId: string
  backgroundImage: string
  mobileBackgroundImage: string
  background: BackgroundStylesInterface
  mobileBackground?: BackgroundStylesInterface
}

const SectionUi = styled.section.attrs<SectionUiProps>(p => ({
  id: p.htmlAttrId,
}))<SectionUiProps>`
  display: flex;
  position: relative;
  ${containerCss}
  background-image:${p => p.backgroundImage};
  ${p => p.background && getDetectedBackgroundStyles(p.background)}

  ${p => p.theme.phone} {
    background-image: ${p => p.mobileBackgroundImage};
    ${p => p.mobileBackground && getDetectedBackgroundStyles(p.mobileBackground)}
    }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      background-image: ${p.mobileBackgroundImage};
      ${p.mobileBackground && getDetectedBackgroundStyles(p.mobileBackground)}
    `}

  ${p =>
    backgroundImageFixForIOS(
      !!(p.mobileBackgroundImage || p.backgroundImage),
      p.mobileBackground?.backgroundAttachment ??
        p.background?.backgroundAttachment ??
        '',
    )}
`

export default SectionUi
